class JavaScriptInjectedSection extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Getting the parent under which we need to show the menu
    this.targetLocationSelector = this.dataset['targetLocation'];
    this.targetLocation = document.querySelector(this.targetLocationSelector);

    if(this.targetLocation) {
      this.targetLocation.innerHTML = this.innerHTML;
    }
  }
}
customElements.define('javascript-injected-section', JavaScriptInjectedSection);

class JavaScriptInjectedSectionHamburger extends JavaScriptInjectedSection {
  constructor() {
    super();
  }

  connectedCallback() {
    document.querySelector('header-drawer').bindEvents();
    this.initMobile();
  }

  //to append the megamenu once the drawer is loaded 
  initMobile(){
    const mobileMegaItems = document.querySelectorAll('javascript-injected-section-mobile');
    mobileMegaItems.forEach((item) => {
      const targetLocationSelectorMobile = item.dataset['targetLocationMobile'];
      const targetLocationMobile = document.querySelector(targetLocationSelectorMobile);
      if(targetLocationMobile) {
        targetLocationMobile.closest('.menu-drawer__inner-submenu').append(item.querySelector('.list-menu').cloneNode(true));
        targetLocationMobile.remove();
      }
    })
  }

}
customElements.define('javascript-injected-section-hamburger', JavaScriptInjectedSectionHamburger);
